import { some as _some } from 'lodash-es';
/**
 *
 * @param {*} roles - roles inside $auth.user()
 * @returns
 */
export const canUpdateCreateGroups = (roles) => {
  if (!roles) return false;

  const isAdmin = _some(roles, { name: 'super-administrator' });
  const isAccountManager = _some(roles, { name: 'account-manager' });
  const isSpecificDealer = _some(roles, { name: 'specific-dealer-manager' });
  const isSalesPerson = _some(roles, { name: 'salesperson' });

  return isAdmin || isAccountManager || isSpecificDealer || isSalesPerson;
};
